const colors = {
  background: '#1F0808',
  clear: 'rgba(0,0,0,0)',
  facebook: '#3b5998',
  transparent: 'rgba(0,0,0,0)',
  silver: '#F7F7F7',
  steel: '#CCCCCC',
  error: 'rgba(200, 0, 0, 0.8)',
  ricePaper: 'rgba(255,255,255, 0.75)',
  frost: '#D8D8D8',
  cloud: 'rgba(200,200,200, 0.35)',
  windowTint: 'rgba(0, 0, 0, 0.4)',
  panther: '#161616',
  charcoal: '#595959',
  coal: '#2d2d2d',
  bloodOrange: '#fb5f26',
  snow: 'white',
  ember: 'rgba(164, 0, 48, 0.5)',
  ember1: 'rgba(164, 0, 48, 1)',
  fire: '#e73536',
  drawer: 'rgba(30, 30, 29, 0.95)',
  eggplant: '#251a34',
  border: '#D8D8D8',
  banner: '#5F3E63',
  text: '#E0D7E5',
  red: 'red',

  headerFont: '#ffffff',
  headerBackground: '#33A2B6',

  Primary: '#ba000d',
  Darker: '#2E8C9D',
  Secondary: '#FEAF06',

  font: '#6B6B6B',
  loading: '#C9C9C9',
  form: '#E2E2E2',

  white: '#ffffff',
  black: '#000',
  backdrop: 'rgba(255, 255, 255, 0.92)',
  avatarBg: '#c4cdc8',

  gold: '#fdd835',
  bronze: '#8d6e63',

  yellow: '#ffd54f',
}

export default colors



// WEBPACK FOOTER //
// ./src/assets/colors.js